import { createAction } from "redux-actions";
import { apiGet, apiPost, apiDelete } from "../../api/index";
import {
  urlStandAloneSecured,
  urlAddBBStandAloneSecured,
  urlFinishStandAloneSecured,
  urlRemoveItemStandAloneSecured,
  urlExpeditionSecured,
  urlAddBBExpSecured,
  urlRemoveItemExpSecured,
  urlFinishExpSecured,
  urlDeleteExpSecured,
} from "../../api/urls";

/**
 * Get junction data.
 */
export const getStandAloneProcessData = createAction(
  "GET_STANDALONE_DATA",
  (param) => apiGet(urlStandAloneSecured, param, true)()
);

/**
 * Register auxItems.
 */
export const register = createAction("CREATE_STANDALONE", (obj, param) =>
  apiPost(urlStandAloneSecured, obj, param, true)()
);

/**
 * Register auxItems.
 */
export const addBB = createAction("REGISTER_BB", (obj, param) =>
  apiPost(urlAddBBStandAloneSecured, obj, param, true)()
);

/**
 * Finish.
 */
export const finish = createAction("FINISH_STANDALONE", (param) =>
  apiPost(urlFinishStandAloneSecured, {}, param, true)()
);

/**
 * Finish.
 */
export const remove = createAction("FINISH_STANDALONE", (param) =>
  apiDelete(urlRemoveItemStandAloneSecured, param, true)()
);

/**
 * Register auxItems.
 */
export const registerExpedition = createAction("CREATE_EXPEDITION", (obj) =>
  apiPost(urlExpeditionSecured, obj, null, true)()
);

/**
 * Get junction data.
 */
export const getExpeditionData = createAction("GET_EXPEDITION_DATA", (param) =>
  apiGet(urlExpeditionSecured, undefined, true)()
);

/**
 * Register auxItems.
 */
export const addBBExp = createAction("REGISTER_BB", (obj, param) =>
  apiPost(urlAddBBExpSecured, obj, param, true)()
);

/**
 * Finish.
 */
export const removeExp = createAction("FINISH_STANDALONE", (param) =>
  apiDelete(urlRemoveItemExpSecured, param, true)()
);

/**
 * Finish.
 */
export const finishExp = createAction("FINISH_STANDALONE", () =>
  apiPost(urlFinishExpSecured, {}, null, true)()
);


/**
 * Finish.
 */
export const removeStandAloneProcess = createAction("FINISH_STANDALONE", (param) =>
  apiDelete(urlDeleteExpSecured, param, true)()
);